export const dataHooks = {
    START_FIXED_ELEMENT: 'start-fixed-element',
    END_FIXED_ELEMENT: 'end-fixed-element',
};
export const StripPosition = {
    LEFT: 'left',
    RIGHT: 'right',
};
//# sourceMappingURL=constants.js.map